<ng-container *ngIf="cashcutList$ | async as cashcutList">
  <hr *ngIf="cashcutList.items.length > 0" />
  <app-cashcut-list-item
    *ngFor="let c of cashcutList.items"
    [cashcutListItem]="c"
    (click)="onShowCashcutDetails(c)"
  ></app-cashcut-list-item>
  <hr class="no-print" />
  <div class="controls no-print">
    <button
      type="button"
      class="btn"
      (click)="loadMore()"
      *ngIf="!cashcutList.isLast; else noMoreCashcuts"
    >
      {{ "home.cashcut-list.controls.load-more" | translate }}
    </button>
    <ng-template #noMoreCashcuts>
      <span>
        {{ "home.cashcut-list.controls.no-more" | translate }}
      </span>
    </ng-template>
  </div>
</ng-container>
